import MainImpactDashboard from "../../components/impact-dashboard/main-impact";

function Impact() {
  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
      <MainImpactDashboard/>
    </div>
  );
}

export default Impact;


